import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { ROUTES } from '../constants/routes';
import ConfirmNavigationModal from './ConfirmNavigationModal';

function SubAppHeaderActions({
  subAppHomePath,
  subAppHomeLabel,
  confirmMessage = 'You may lose unsaved work on this screen.',
  navButtonClassName = 'btn btn-outline-secondary btn-sm',
}) {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);

  const handleLeave = () => {
    setShowConfirm(false);
    navigate(subAppHomePath);
  };

  return (
    <>
      <div className="d-flex align-items-center flex-wrap gap-2">
        <span className="text-muted small">
          {user?.name} ({user?.role_key || user?.role})
        </span>
        <button
          type="button"
          className={navButtonClassName}
          onClick={() => setShowConfirm(true)}
        >
          Back to {subAppHomeLabel}
        </button>
        <button
          type="button"
          className={navButtonClassName}
          onClick={() => navigate(ROUTES.HOME)}
        >
          Compass App
        </button>
        <button
          type="button"
          className="btn btn-outline-danger btn-sm"
          onClick={() => {
            logout();
            navigate(ROUTES.LOGIN);
          }}
        >
          Logout
        </button>
      </div>
      <ConfirmNavigationModal
        show={showConfirm}
        title="Leave this page?"
        message={confirmMessage}
        onConfirm={handleLeave}
        onCancel={() => setShowConfirm(false)}
      />
    </>
  );
}

export default SubAppHeaderActions;
